<div style="display: flex;justify-content: center;height: 100vh;font-size:1.25rem;">
    <span style="text-align: center;">
        <p>Redirecting to emissions.AI</p>
        <p style="font-weight:600; color:#7cae15;"><a target="_blank" [href]="redirectUrl">{{redirectUrl}}</a></p>
    </span>
</div>